import React from "react";

export const MobileInfoItem = ({ label, value, danger }) => (
    <div className="mobile-info-item">
        <div className="mobile-info-item__label">{label}</div>
        <div
            className={`mobile-info-item__value ${
                danger ? "mobile-info-item__value--danger" : "mobile-info-item__value--normal"
            }`}
        >
            {value}
        </div>
    </div>
);
